module.exports = __webpack_public_path__ + "img/background.4d7c3fd2.jpg";